import { MutableRefObject, useEffect } from 'react';
import {
  IOffsiteTemplatePreviewResponse,
  OnsiteTemplatePreviewQueryResponse,
} from 'sections/design/template-management/entities/templates';
import { useUpdateTemplate } from './useUpdateTemplate';
import { useUpdatePreview } from './useUpdatePreview';
import { isObjectEmpty } from '../utils/validation-helpers';
import { useSetEnrichmentsContext } from './useSetEnrichmentsContext';

export const useListenAndUpdateTemplateAndPreview = (
  isPreviewButtonClicked: MutableRefObject<boolean>,
  data: IOffsiteTemplatePreviewResponse | OnsiteTemplatePreviewQueryResponse,
) => {
  const updatePreview = useUpdatePreview(data);
  const updateTemplate = useUpdateTemplate(isPreviewButtonClicked, data);
  const setEnrichmentsContext = useSetEnrichmentsContext(data);

  useEffect(() => {
    if (!data) {
      return;
    }

    updatePreview();
    updateTemplate();

    if (!isObjectEmpty((data as IOffsiteTemplatePreviewResponse).enrichments)) {
      setEnrichmentsContext();
    }
  }, [data, updatePreview, updateTemplate, setEnrichmentsContext]);
};
